// import React, { useEffect, useState } from "react";
// import { getLiveClasses } from "../../lib/LiveClass";
// import { useNavigate, useOutletContext } from "react-router-dom";
// import {
//   getContentsByTopicID,
//   getTopicsByChapter,
//   markAttendance,
// } from "../../lib/LiveclassContent";
// import { useAuth } from "../../context/AuthProvider";

// export default function LiveClasses() {


//   const [selectedSession, setSelectedSession] = useState(null);
//   const [topicContents, setTopicContents] = useState([]);
//   const [contentLoading, setContentLoading] = useState(false);

//   const { selectedDate } = useOutletContext();
//   const [sessions, setSessions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [openDropdown, setOpenDropdown] = useState({});
//   const navigate = useNavigate();

//   //const user = JSON.parse(localStorage.getItem("user") || "{}");

//   const { user } = useAuth();



//   const role =
//     user?.role?.toLowerCase();

//   const isStudent = role === "student";

//   const isTeacher = role === "teacher";

//   const isAdmin = role === "admin";


//   // ================= FILTER =================
//   // const selectedDateString = new Date(selectedDate).toDateString();

//   // const filteredSessions = sessions.filter(
//   //   (session) =>
//   //     new Date(session.startdatetime).toDateString() === selectedDateString
//   // );

//   const filteredSessions = sessions.filter((session) => {
//     const selected = new Date(selectedDate);
//     const start = new Date(session.startdatetime);
//     const end = new Date(session.enddatetime);

//     selected.setHours(0, 0, 0, 0);
//     start.setHours(0, 0, 0, 0);
//     end.setHours(23, 59, 59, 999);

//     return selected >= start && selected <= end;
//   });

//   // ================= NEXT CLASS =================
//   const now = new Date();

//   const nextClass = sessions
//     .filter((session) => new Date(session.startdatetime) > now)
//     .sort(
//       (a, b) =>
//         new Date(a.startdatetime) - new Date(b.startdatetime)
//     )[0];

//   // ================= TODAY SESSIONS =================

//   const todaySessions = sessions.filter(
//     (session) =>
//       new Date(session.startdatetime).toDateString() ===
//       new Date().toDateString()
//   );

//   // Teacher
//   // ================= UPCOMING SESSIONS =================

//   const upcomingSessions = sessions.filter(
//     (session) =>
//       new Date(session.startdatetime) > new Date()
//   );

//   // ================= FETCH =================
//   useEffect(() => {
//     fetchLiveClass();
//   }, []);

//   // const fetchLiveClass = async () => {
//   //   try {
//   //     setLoading(true);

//   //     const userId =
//   //       user?.uuid || user?.id || localStorage.getItem("userId");
//   //       const SchoolId =
//   //       user?.schoolId || user?.SchoolId || localStorage.getItem("schoolId");

//   //     // const response = await getLiveClasses(userId,SchoolId);
//   //     // const res = response?.data || response;
//   //     const response = await getLiveClasses(userId, schoolId);

//   //      setLiveClasses(response?.data || []);

//   //     if (!Array.isArray(res) || res.length === 0) {
//   //       setSessions([]);
//   //       return;
//   //     }

//   //     console.log("Session link Test =======",res);

//   //     const formatted = res.map((item) => ({
//   //       id: item.id,

//   //       startdatetime: item.startdatetime,
//   //       enddatetime: item.enddatetime,
//   //         joinUrl: item.joinUrl,
//   //         hostUrl: item.hostUrl,
//   //      // liveclasslink: item.liveclasslink || item.liveClassLink,
//   //       subject: item.subjectName,
//   //       chapter: item.chapter,
//   //       topicId: item.topicId,
//   //       topic: item.topic,
//   //       teacher: item.teacherName,
//   //       class:item.classname,
//   //       rating: item.rating,
//   //       recordedVideoUrl: item.recordedVideoUrl,
//   //       notesUrl: item.notesUrl,
//   //       testUrl: item.testUrl,
//   //       batchName: item.batchName,

//   //       role: item.role,
//   //     }));
//   //     setSessions(formatted);
//   //   } catch (error) {
//   //     console.error("Live Class API Error:", error);
//   //     setError("Failed to load live classes");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   //===================handleViewDetails======================


//   const fetchLiveClass = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const userId =
//         user?.UserID ||
//         user?.userID ||
//         user?.uuid ||
//         user?.id ||
//         localStorage.getItem("userId");

//       const schoolId =
//         user?.SchoolId ||
//         user?.schoolId ||
//         localStorage.getItem("schoolId");

//       console.log("Live Classes Request:", {
//         userId,
//         schoolId,
//       });

//       if (!userId || !schoolId) {
//         console.error("Missing userId or schoolId:", {
//           userId,
//           schoolId,
//           user,
//         });

//         setError("User ID or School ID is missing.");
//         setSessions([]);
//         return;
//       }

//       const response = await getLiveClasses(userId, schoolId);

//       console.log("Live Classes Full Response:", response);
//       console.log("Live Classes API Data:", response?.data);

//       // Axios response:
//       // response.data = {
//       //   success: true,
//       //   userId: 86,
//       //   schoolId: 14,
//       //   role: "student",
//       //   data: [...]
//       // }

//       // getLiveClasses already returns Axios' response.data, so the API
//       // payload is { success, ..., data: [...] } here.
//       const res = response?.data || [];

//       console.log("Live Classes Array:", res);

//       if (!Array.isArray(res) || res.length === 0) {
//         setSessions([]);
//         return;
//       }

//       const formatted = await Promise.all(res.map(async (item) => {
//         let topicId =
//           item.topicId ??
//           item.topicID ??
//           item.topicid ??
//           item.topic_id;

//         // GetLiveClasses may omit topicId. Resolve it from the chapter and
//         // topic name; sessionId is a different identifier and must not be used.
//         if (!topicId && item.chapterId && item.topic) {
//           try {
//             const topicsResponse = await getTopicsByChapter(item.chapterId);
//             const topics = Array.isArray(topicsResponse?.data)
//               ? topicsResponse.data
//               : Array.isArray(topicsResponse)
//                 ? topicsResponse
//                 : [];

//             const requestedTopic = item.topic.trim().toLowerCase();
//             const matchingTopic = topics.find((topic) => {
//               const name =
//                 topic.topicname ??
//                 topic.topicName ??
//                 topic.TopicName ??
//                 "";

//               return name.trim().toLowerCase() === requestedTopic;
//             });

//             topicId =
//               matchingTopic?.topicid ??
//               matchingTopic?.topicId ??
//               matchingTopic?.TopicId;
//           } catch (topicError) {
//             console.error("Topic lookup failed:", topicError);
//           }
//         }

//         return {
//         id: item.id,
//         startdatetime: item.startdatetime,
//         enddatetime: item.enddatetime,
//         joinUrl: item.joinUrl,
//         hostUrl: item.hostUrl,
//         subject: item.subjectName,
//         chapter: item.chapter,
//         // sessionId is not topicId. Keep topicId undefined when the API
//         // does not provide it instead of sending the wrong identifier.
//         topicId,
//         topic: item.topic,
//         teacher: item.teacherName,
//         class: item.classname,
//         rating: item.rating,
//         recordedVideoUrl: item.recordedVideoUrl,
//         notesUrl: item.notesUrl,
//         testUrl: item.testUrl,
//         batchName: item.batchName,
//         role: item.role,
//         };
//       }));

//       console.log("Formatted Sessions:", formatted);

//       setSessions(formatted);
//     } catch (error) {
//       console.error("Live Class API Error:", error);
//       setError("Failed to load live classes");
//       setSessions([]);
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleViewDetails = async (session) => {

//     try {

//       setSelectedSession(session);

//       setContentLoading(true);

//       const res = await getContentsByTopicID(session.topicId);

//       console.log("FULL RESPONSE:", res);

//       setTopicContents(res || []);

//     } catch (err) {

//       console.error(err);

//     } finally {

//       setContentLoading(false);

//     }

//   };

//   //=====================handlejoinsession==============
//   // const handleJoinSession = async (session) => {

//   //   try {

//   //     const user =
//   //       JSON.parse(localStorage.getItem("user"));

//   //     const payload = {

//   //       userId: user?.uuid,

//   //       liveClassId: session.id,

//   //       topicId: session.topicId,

//   //       deviceType: "Web",

//   //       ipAddress: ""
//   //     };

//   //     // Save Attendance
//   //     await markAttendance(payload);

//   //     // Open Live Class
//   //     // if (session.liveclasslink) {

//   //     //   window.open(
//   //     //     session.liveclasslink,
//   //     //     "_blank"
//   //     //   );
//   //     // }

//   //   } catch (err) {

//   //     console.error(
//   //       "Attendance Error:",
//   //       err
//   //     );
//   //   }
//   // };

//   //   const handleJoinSession = async (session) => {
//   //   try {
//   //     const user =
//   //       JSON.parse(localStorage.getItem("user"));

//   //     const payload = {
//   //       userId: user?.uuid,
//   //       liveClassId: session.id,
//   //       topicId: session.topicId,
//   //       deviceType: "Web",
//   //       ipAddress: ""
//   //     };

//   //     await markAttendance(payload);

//   //     if (session.liveclasslink) {
//   //       window.open(
//   //         session.liveclasslink,
//   //         "_blank"
//   //       );
//   //     }

//   //   } catch (err) {
//   //     console.error(err);
//   //   }
//   // };

//   //============Handle student session================

//   const handleStudentJoin = async (session) => {
//     try {
//       const user = JSON.parse(
//         localStorage.getItem("user") || "{}"
//       );

//       const userId =
//         user?.UserID ||
//         user?.userID ||
//         user?.id ||
//         user?.uuid;

//       if (!userId || !session?.id) {
//         console.error("Invalid attendance data:", {
//           userId,
//           liveClassId: session?.id,
//           topicId: session?.topicId,
//           session,
//         });
//         alert("Cannot join because live class details are missing.");
//         return;
//       }

//       if (!session.joinUrl) {
//         alert("Live class link is not available.");
//         return;
//       }

//       // Open immediately from the click event so the browser does not block
//       // the Zoom tab while the attendance request is running.
//       window.open(session.joinUrl, "_blank", "noopener,noreferrer");

//       if (session.topicId) {
//         const payload = {
//           userId,
//           liveClassId: session.id,
//           topicId: session.topicId,
//           deviceType: "Web",
//           ipAddress: "",
//         };

//         console.log("MarkAttendance payload:", payload);

//         try {
//           await markAttendance(payload);
//         } catch (attendanceError) {
//           // Attendance failure should not prevent the student from joining Zoom.
//           console.error("Attendance API error:", attendanceError);
//         }
//       } else {
//         console.warn(
//           "Topic ID is missing; joining Zoom without marking attendance."
//         );
//       }

//     } catch (err) {
//       console.error(err);
//     }
//   };


//   //==================Handle Teacher Session===========
//   const handleTeacherJoin = (session) => {
//     const teacherUrl = session.hostUrl || session.joinUrl;

//     if (teacherUrl) {
//       window.open(teacherUrl, "_blank", "noopener,noreferrer");
//     } else {
//       alert("Live class link is not available.");
//     }
//   };

//   //====================GroupContent=======================

//   const groupedContents = topicContents.reduce((acc, item) => {

//     const type = item.mediatype?.toLowerCase();

//     if (!acc[type]) {
//       acc[type] = [];
//     }

//     acc[type].push(item);

//     return acc;

//   }, {});


//   // ================= SESSION STATUS =================

//   const getSessionStatus = (session) => {

//     const now = new Date();

//     const start = new Date(session.startdatetime);

//     const end = new Date(session.enddatetime);

//     if (now < start) {
//       return "Upcoming";
//     }

//     if (now > end) {
//       return "Completed";
//     }

//     return "Live";
//   };

//   return (
//     <div className="min-h-screen bg-secondary p-4 md:p-6">

//       {/* ================= STATES ================= */}
//       {loading && (
//         <div className="text-center py-10 text-gray-500">
//           Loading sessions...
//         </div>
//       )}

//       {error && (
//         <div className="text-center text-red-500 py-4">{error}</div>
//       )}

//       {!loading && sessions.length === 0 && (
//         <div className="text-center text-black py-10">
//           No sessions available
//         </div>
//       )}

//       {/* ================= MAIN ================= */}
//       {/* ================= MAIN ================= */}

//       {/* ===================================================== */
// /* STUDENT UI */
// /* ===================================================== */}

//       {isStudent &&
//         !loading &&
//         sessions.length > 0 &&
//         !selectedSession && (

//           filteredSessions.length === 0 ? (

//             <div className="text-center py-10">

//               <p className="text-red-500 font-medium">
//                 There are no classes scheduled today
//               </p>

//               {nextClass && (
//                 <p className="text-sm text-gray-500 mt-2">
//                   Your next class:
//                   {" "}
//                   {new Date(
//                     nextClass.startdatetime
//                   ).toLocaleString()}
//                 </p>
//               )}

//             </div>

//           ) : (

//             <div>

//               {/* SESSION HEADER */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
//                 {/* <div className="hidden md:block font-semibold text-gray-600">
//                 Sessions
//               </div> */}

//                 {filteredSessions.map((s, i) => (
//                   <div
//                     key={i}
//                     className="bg-gray-300 mb-2 px-4 py-2 rounded-md flex justify-between items-center text-sm font-medium"
//                   >
//                     <span>
//                       Session {i + 1} |{" "}
//                       {new Date(s.startdatetime).toLocaleTimeString([], {
//                         hour: "2-digit",
//                         minute: "2-digit",
//                       })}
//                     </span>
//                     <span>▼</span>
//                   </div>
//                 ))}
//               </div>

//               {/* TABLE */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

//                 {/* LEFT LABELS */}
//                 {/* <div className="hidden md:flex flex-col text-sm text-gray-600 space-y-4 pt-2">
//                 <p>Time Slot (IST):</p>
//                 <p>Subject:</p>
//                 <p>Chapter:</p>
//                 <p>Topic:</p>
//                 <p>Teacher:</p>
//               </div> */}

//                 {/* SESSION DATA */}
//                 {filteredSessions.map((s) => {
//                   const start = new Date(s.startdatetime);
//                   const end = new Date(s.enddatetime);
//                   const now = Date.now();

//                   const isLive =
//                     now >= start.getTime() &&
//                     now <= end.getTime();

//                   return (
//                     <div
//                       key={s.id}
//                       className="bg-white rounded-md p-4 shadow-sm flex flex-col justify-between"
//                     >
//                       <div className="space-y-4 text-sm text-gray-700">
//                         <p>
//                           <span className="text-black-900 font-bold">Time:</span>
//                           {start.toLocaleTimeString()} -{" "}
//                           {end.toLocaleTimeString()}
//                         </p>
//                         <p><span className="text-black-900 font-bold">Subject:</span>  {s.subject || "-"}</p>
//                         <p><span className="text-black-900 font-bold">Chapter:</span> {s.chapter || "-"}</p>
//                         <p><span className="text-black-900 font-bold">Topic:</span> {s.topic || "-"}</p>
//                         <p>
//                           <span className="text-black-900 font-bold">Teacher:</span>
//                           {s.teacher || "-"}{" "}
//                           {/* {s.rating && (
//                           // <span className="ml-2 text-yellow-500">
//                           //   ⭐ {s.rating}
//                           // </span>
//                         )} */}
//                         </p>
//                       </div>

//                       <div className="mt-4">
//                         <button
//                           // onClick={() =>
//                           //   s.liveclasslink &&
//                           //   window.open(s.liveclasslink, "_blank")
//                           // }
//                           // disabled={!isLive}
//                           // className={`w-full py-2 rounded-md text-sm font-medium ${
//                           //   isLive
//                           //     ? "bg-red-600 text-white"
//                           //     : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                           // }`}
//                           onClick={() => handleStudentJoin(s)}
//                           disabled={!isLive}
//                           className={`w-full py-2 rounded-md text-sm font-medium ${isLive
//                             ? "bg-red-600 text-white"
//                             : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                             }`}
//                         >
//                           {isLive ? "Join Live" : "Not Live Yet"}


//                         </button>

//                         <p className="text-xs text-red-500 text-center mt-2">
//                           Attendance marked on joining
//                         </p>
//                       </div>

//                       {/* <button
//                         onClick={() => handleViewDetails(s)}
//                         className="bg-primary text-white px-3 py-1 rounded"
//                       >
//                         View Details
//                       </button> */}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )
//         )}

//       {/* ===================================================== */
//         /* TEACHER UI */
//        /* ===================================================== */}

//       {isTeacher &&
//         !loading &&
//         !selectedSession && (

//           <div className="space-y-8">

//             {/* TODAY SESSIONS */}

//             <div>

//               {/* SESSION HEADER */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
//                 {/* <div className="hidden md:block font-semibold text-gray-600">
//                 Sessions
//               </div> */}

//                 {filteredSessions.map((s, i) => (
//                   <div
//                     key={i}
//                     className="bg-gray-300 mb-2 px-4 py-2 rounded-md flex justify-between items-center text-sm font-medium"
//                   >
//                     <span>
//                       Session {i + 1} |{" "}
//                       {new Date(s.startdatetime).toLocaleTimeString([], {
//                         hour: "2-digit",
//                         minute: "2-digit",
//                       })}
//                     </span>
//                     <span>▼</span>
//                   </div>
//                 ))}
//               </div>

//               {/* TABLE */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

//                 {/* LEFT LABELS */}
//                 {/* <div className="hidden md:flex flex-col text-sm text-gray-600 space-y-4 pt-2">
//                 <p>Time Slot (IST):</p>
//                 <p>Subject:</p>
//                 <p>Chapter:</p>
//                 <p>Topic:</p>
//                 <p>Teacher:</p>
//               </div> */}

//                 {/* SESSION DATA */}
//                 {filteredSessions.map((s) => {
//                   const start = new Date(s.startdatetime);
//                   const end = new Date(s.enddatetime);
//                   const now = Date.now();

//                   const isLive =
//                     now >= start.getTime() &&
//                     now <= end.getTime();

//                   return (
//                     <div
//                       key={s.id}
//                       className="bg-white rounded-md p-4 shadow-sm flex flex-col justify-between"
//                     >
//                       <div className="space-y-4 text-sm text-gray-700">
//                         <p>
//                           <span className="text-black-900 font-bold">Time:</span>
//                           {start.toLocaleTimeString()} -{" "}
//                           {end.toLocaleTimeString()}
//                         </p>
//                         <p><span className="text-black-900 font-bold">Subject:</span>  {s.subject || "-"}</p>
//                         <p><span className="text-black-900 font-bold">Chapter:</span> {s.chapter || "-"}</p>
//                         <p><span className="text-black-900 font-bold">Topic:</span> {s.topic || "-"}</p>
//                         <p>
//                           <span className="text-black-900 font-bold">Class:</span>
//                           {s.class || "-"}{" "}
//                           {/* {s.rating && (
//                           // <span className="ml-2 text-yellow-500">
//                           //   ⭐ {s.rating}
//                           // </span>
//                         )} */}
//                         </p>
//                       </div>

//                       <div className="mt-4">
//                         <button
//                           // onClick={() =>
//                           //   s.liveclasslink &&
//                           //   window.open(s.liveclasslink, "_blank")
//                           // }
//                           // disabled={!isLive}
//                           // className={`w-full py-2 rounded-md text-sm font-medium ${
//                           //   isLive
//                           //     ? "bg-red-600 text-white"
//                           //     : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                           // }`}
//                           onClick={() => handleTeacherJoin(s)}
//                           disabled={!isLive}
//                           className={`w-full py-2 rounded-md text-sm font-medium ${isLive
//                             ? "bg-red-600 text-white"
//                             : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                             }`}
//                         >
//                           {isLive ? "Join Session" : "Not Live Yet"}


//                         </button>

//                         {/* <p className="text-xs text-red-500 text-center mt-2">
//                           Attendance marked on joining
//                         </p> */}
//                       </div>

//                       {/* <button
//                         onClick={() => handleViewDetails(s)}
//                         className="bg-primary text-white px-3 py-1 rounded"
//                       >
//                         View Details
//                       </button> */}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//           </div>
//         )}
//     </div>
//   );
// }






import React, { useEffect, useState } from "react";

import { getLiveClasses } from "../../lib/LiveClass";
import { useNavigate, useOutletContext } from "react-router-dom";

import {
  getContentsByTopicID,
  markAttendance,
} from "../../lib/LiveclassContent";

import { useAuth } from "../../context/AuthProvider";


// =====================================================
// MAIN COMPONENT
// =====================================================

export default function LiveClasses() {
  const [selectedSession, setSelectedSession] =
    useState(null);

  const [topicContents, setTopicContents] =
    useState([]);

  const [contentLoading, setContentLoading] =
    useState(false);

  const { selectedDate } =
    useOutletContext();

  const [sessions, setSessions] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  const navigate = useNavigate();

  const { user } = useAuth();


  // =====================================================
  // ROLE
  // =====================================================

  const role =
    user?.role?.toLowerCase();

  const isStudent =
    role === "student";

  const isTeacher =
    role === "teacher";

  const isAdmin =
    role === "admin";


  // =====================================================
  // FILTER SESSIONS BY SELECTED DATE
  // =====================================================

  const filteredSessions =
    sessions.filter((session) => {
      const selected =
        new Date(selectedDate);

      const start =
        new Date(
          session.startdatetime
        );

      const end =
        new Date(
          session.enddatetime
        );

      selected.setHours(
        0,
        0,
        0,
        0
      );

      start.setHours(
        0,
        0,
        0,
        0
      );

      end.setHours(
        23,
        59,
        59,
        999
      );

      return (
        selected >= start &&
        selected <= end
      );
    });


  // =====================================================
  // NEXT CLASS
  // =====================================================

  const now =
    new Date();

  const nextClass =
    sessions
      .filter(
        (session) =>
          new Date(
            session.startdatetime
          ) > now
      )
      .sort(
        (a, b) =>
          new Date(
            a.startdatetime
          ) -
          new Date(
            b.startdatetime
          )
      )[0];


  // =====================================================
  // FETCH LIVE CLASSES
  // =====================================================

  useEffect(() => {
    fetchLiveClass();
  }, []);


  const fetchLiveClass =
    async () => {
      try {
        setLoading(true);
        setError("");

        // =============================================
        // SAME USER ID LOGIC
        // =============================================

        const userId =
          user?.UserID ||
          user?.userID ||
          user?.uuid ||
          user?.id ||
          localStorage.getItem(
            "userId"
          );


        // =============================================
        // SAME SCHOOL ID LOGIC
        // =============================================

        const schoolId =
          user?.SchoolId ||
          user?.schoolId ||
          localStorage.getItem(
            "schoolId"
          );


        console.log(
          "Live Classes Request:",
          {
            userId,
            schoolId,
          }
        );


        if (
          !userId ||
          !schoolId
        ) {
          console.error(
            "Missing userId or schoolId:",
            {
              userId,
              schoolId,
              user,
            }
          );

          setError(
            "User ID or School ID is missing."
          );

          setSessions([]);

          return;
        }


        // =============================================
        // SAME API CALL
        // =============================================

        const response =
          await getLiveClasses(
            userId,
            schoolId
          );


        console.log(
          "Live Classes Full Response:",
          response
        );

        console.log(
          "Live Classes API Data:",
          response?.data
        );


        // =============================================
        // SAME API RESPONSE MAPPING
        // =============================================

        const res =
          response?.data || [];


        console.log(
          "Live Classes Array:",
          res
        );


        if (
          !Array.isArray(res) ||
          res.length === 0
        ) {
          setSessions([]);

          return;
        }


        const formatted =
          res.map(
            (item) => ({
              id:
                item.id ??
                item.sessionId ??
                item.sessionid ??
                item.liveClassId ??
                item.liveClassID ??
                item.liveclassid ??
                item.LiveClassId ??
                item.LiveClassID ??
                null,

              startdatetime:
                item.startdatetime,

              enddatetime:
                item.enddatetime,

              joinUrl:
                item.joinUrl,

              hostUrl:
                item.hostUrl,

              subject:
                item.subjectName,

              chapter:
                item.chapter,

              /*
               * IMPORTANT:
               * topicId must come from the topic identifier only.
               * sessionId is a different value and must not be sent as topicId.
               */
              topicId:
                item.topicId ??
                item.topicID ??
                item.topicid ??
                item.topic_id ??
                null,

              topic:
                item.topic,

              teacher:
                item.teacherName,

              class:
                item.classname,

              rating:
                item.rating,

              recordedVideoUrl:
                item.recordedVideoUrl,

              notesUrl:
                item.notesUrl,

              testUrl:
                item.testUrl,

              batchName:
                item.batchName,

              role:
                item.role,
            })
          );


        console.log(
          "Formatted Sessions:",
          formatted
        );


        setSessions(
          formatted
        );

      } catch (error) {
        console.error(
          "Live Class API Error:",
          error
        );

        setError(
          "Failed to load live classes"
        );

        setSessions([]);

      } finally {
        setLoading(false);
      }
    };


  // =====================================================
  // VIEW CONTENT DETAILS
  // =====================================================

  const handleViewDetails =
    async (session) => {
      try {
        setSelectedSession(
          session
        );

        setContentLoading(
          true
        );

        const res =
          await getContentsByTopicID(
            session.topicId
          );

        console.log(
          "FULL RESPONSE:",
          res
        );

        setTopicContents(
          res || []
        );

      } catch (err) {
        console.error(
          err
        );

        setTopicContents([]);

      } finally {
        setContentLoading(
          false
        );
      }
    };


  // =====================================================
  // STUDENT JOIN
  // =====================================================

  const handleStudentJoin =
    async (session) => {
      try {
        const storedUser =
          JSON.parse(
            localStorage.getItem(
              "user"
            ) || "{}"
          );


        const userId =
          storedUser?.UserID ||
          storedUser?.userID ||
          storedUser?.id ||
          storedUser?.uuid;

        const schoolId =
          storedUser?.SchoolId ||
          storedUser?.schoolId ||
          storedUser?.schoolID ||
          localStorage.getItem("schoolId");


        if (
          !userId ||
          !session?.id
        ) {
          console.error(
            "Invalid attendance data:",
            {
              userId,
              liveClassId:
                session?.id,
              topicId:
                session?.topicId,
              session,
            }
          );

          return;
        }


        // =============================================
        // ATTENDANCE API
        // Always try attendance when the user clicks join.
        // Do not bind sessionId into topicId.
        // =============================================

        try {
          const attendancePayload = {
            userId:
              userId,

            schoolId:
              Number(schoolId),

            liveClassId:
              session.id,

            deviceType:
              "Web",

            ipAddress:
              "",
          };

          if (
            session.topicId !==
              null &&
            session.topicId !==
              undefined &&
            session.topicId !==
              ""
          ) {
            attendancePayload.topicId =
              Number(session.topicId);
          }

          await markAttendance(
            attendancePayload
          );
        } catch (
          attendanceError
        ) {
          console.error(
            "Attendance API error:",
            attendanceError
          );
        }

        if (
          !session?.joinUrl
        ) {
          alert(
            "Live class link is not available."
          );

          return;
        }


        // =============================================
        // OPEN ZOOM
        // =============================================

        window.open(
          session.joinUrl,
          "_blank",
          "noopener,noreferrer"
        );

      } catch (err) {
        console.error(
          err
        );
      }
    };


  // =====================================================
  // TEACHER JOIN
  // =====================================================

  const handleTeacherJoin =
    (session) => {
      if (
        session?.hostUrl
      ) {
        window.open(
          session.hostUrl,
          "_blank",
          "noopener,noreferrer"
        );
      }
    };


  // =====================================================
  // SESSION STATUS
  // =====================================================

  const isSessionLive =
    (session) => {
      const current =
        Date.now();

      const start =
        new Date(
          session.startdatetime
        ).getTime();

      const end =
        new Date(
          session.enddatetime
        ).getTime();

      return (
        current >= start &&
        current <= end
      );
    };


  // =====================================================
  // FORMAT TIME
  // =====================================================

  const formatTime =
    (date) => {
      if (!date) {
        return "-";
      }

      return new Date(
        date
      ).toLocaleTimeString(
        [],
        {
          hour:
            "numeric",

          minute:
            "2-digit",
        }
      );
    };


  // =====================================================
  // JOIN BUTTON
  // =====================================================

  const JoinButton = ({
    session,
  }) => {
    const isLive =
      isSessionLive(
        session
      );


    const handleJoin =
      () => {
        if (isStudent) {
          handleStudentJoin(
            session
          );
        } else {
          handleTeacherJoin(
            session
          );
        }
      };


    return (
      <div
        className="
          w-full
          min-w-0
        "
      >
        <button
          type="button"
          onClick={
            handleJoin
          }
          disabled={
            !isLive
          }
          className={`
            inline-flex
            items-center
            justify-center

            w-full
            sm:w-auto

            min-h-[48px]

            px-6
            sm:px-7

            rounded-full

            text-sm
            sm:text-base

            font-semibold

            transition

            ${
              isLive
                ? "bg-[#D54B32] text-white hover:bg-[#C6422A]"
                : "bg-white text-[#AAA5B4] border border-[#E8E1D5] cursor-not-allowed"
            }
          `}
        >
          Join session
        </button>


        {isStudent && (
          <p
            className="
              mt-3

              text-sm
              leading-5

              text-[#D54B32]

              break-words
            "
          >
            Attendance is marked
            on joining the session.
          </p>
        )}


        {!isStudent && (
          <p
            className="
              mt-3

              text-sm
              leading-5

              text-[#8C83AE]

              break-words
            "
          >
            Session will unlock
            when it starts.
          </p>
        )}
      </div>
    );
  };


  // =====================================================
  // MOBILE / TABLET CARD
  // =====================================================

  const SessionCard =
    ({
      session,
      index,
    }) => {
      return (
        <div
          className="
            w-full
            min-w-0
            max-w-full

            rounded-[14px]

            border
            border-[#E5DDCF]

            bg-[#F8F4EA]

            overflow-hidden
          "
        >

          {/* ===========================================
              HEADER
          =========================================== */}

          <div
            className="
              w-full
              min-w-0

              px-4
              sm:px-5

              py-4

              rounded-t-[14px]

              bg-[#E8E3E7]

              border-b
              border-[#DDD3C5]
            "
          >
            <p
              className="
                text-[#2519BD]

                text-[16px]
                sm:text-[17px]

                font-medium
                leading-6

                break-words
                overflow-wrap-anywhere
              "
            >
              Session{" "}
              {index + 1}
              {" | "}
              {formatTime(
                session.startdatetime
              )}
              {" | "}
              {session.subject ||
                "-"}
            </p>
          </div>


          {/* ===========================================
              INFORMATION
          =========================================== */}

          <div
            className="
              w-full
              min-w-0

              divide-y
              divide-[#E5DDCF]
            "
          >

            <MobileInfoRow
              label="Time slot (IST)"
              value={
                <>
                  {formatTime(
                    session.startdatetime
                  )}
                  {" - "}
                  {formatTime(
                    session.enddatetime
                  )}
                </>
              }
            />


            <MobileInfoRow
              label="Subject"
              value={
                session.subject ||
                "-"
              }
            />


            <MobileInfoRow
              label="Chapter"
              value={
                session.chapter ||
                "-"
              }
            />


            <MobileInfoRow
              label="Topic"
              value={
                session.topic ||
                "-"
              }
            />


            <MobileInfoRow
              label={
                isTeacher
                  ? "Class"
                  : "Teacher"
              }
              value={
                isTeacher
                  ? session.class ||
                    "-"
                  : session.teacher ||
                    "-"
              }
              rating={
                session.rating
              }
            />

          </div>


          {/* ===========================================
              ACTION
          =========================================== */}

          <div
            className="
              w-full
              min-w-0

              px-4
              sm:px-5

              py-5
            "
          >
            <JoinButton
              session={
                session
              }
            />
          </div>

        </div>
      );
    };


  // =====================================================
  // DESKTOP TABLE
  // =====================================================

  const DesktopSessionTable =
    () => {
      const count =
        Math.max(
          filteredSessions.length,
          1
        );


      return (
        <div
          className="
            hidden
            lg:block

            w-full
            max-w-full

            min-w-0

            overflow-hidden
          "
        >

          {/* ===========================================
              SESSION HEADERS
          =========================================== */}

          <div
            className="
              grid

              w-full
              max-w-full

              min-w-0

              gap-3
              mb-3
            "
            style={{
              gridTemplateColumns:
                `minmax(150px, 0.7fr) repeat(${count}, minmax(0, 1fr))`,
            }}
          >

            <div
              className="
                min-w-0

                rounded-xl

                bg-[#F2ECDD]

                px-4
                py-5

                flex
                items-center

                font-semibold

                text-[#151A50]

                break-words
              "
            >
              Sessions
            </div>


            {filteredSessions.map(
              (
                session,
                index
              ) => (
                <div
                  key={
                    `header-${session.id}`
                  }
                  className="
                    min-w-0
                    max-w-full

                    rounded-xl

                    bg-[#E8E3E7]

                    border
                    border-[#DCD2C5]

                    px-4
                    py-4

                    flex
                    items-center

                    text-[#2519BD]

                    text-[15px]

                    font-medium

                    break-words
                    overflow-hidden
                  "
                >
                  Session{" "}
                  {index + 1}
                  {" | "}
                  {formatTime(
                    session.startdatetime
                  )}
                  {" | "}
                  {session.subject ||
                    "-"}
                </div>
              )
            )}

          </div>


          {/* ===========================================
              TABLE
          =========================================== */}

          <div
            className="
              w-full
              max-w-full

              min-w-0

              rounded-[14px]

              border
              border-[#E5DDCF]

              overflow-hidden
            "
          >

            <DesktopRow
              label="Time slot (IST)"
              sessions={
                filteredSessions
              }
              renderValue={
                (session) => (
                  <>
                    {formatTime(
                      session.startdatetime
                    )}
                    {" - "}
                    {formatTime(
                      session.enddatetime
                    )}
                  </>
                )
              }
            />


            <DesktopRow
              label="Subject"
              sessions={
                filteredSessions
              }
              renderValue={
                (session) =>
                  session.subject ||
                  "-"
              }
            />


            <DesktopRow
              label="Chapter"
              sessions={
                filteredSessions
              }
              renderValue={
                (session) =>
                  session.chapter ||
                  "-"
              }
            />


            <DesktopRow
              label="Topic"
              sessions={
                filteredSessions
              }
              renderValue={
                (session) =>
                  session.topic ||
                  "-"
              }
            />


            <DesktopRow
              label={
                isTeacher
                  ? "Class"
                  : "Teacher"
              }
              sessions={
                filteredSessions
              }
              last
              renderValue={
                (session) => (
                  <>
                    {isTeacher
                      ? session.class ||
                        "-"
                      : session.teacher ||
                        "-"}

                    {session.rating && (
                      <span
                        className="
                          inline-flex
                          ml-2
                          mt-1

                          px-2
                          py-1

                          rounded-full

                          border
                          border-[#DCCFB8]

                          text-xs

                          text-[#716A80]

                          whitespace-nowrap
                        "
                      >
                        ★{" "}
                        {
                          session.rating
                        }
                      </span>
                    )}
                  </>
                )
              }
            />

          </div>


          {/* ===========================================
              ACTIONS
          =========================================== */}

          <div
            className="
              grid

              w-full
              max-w-full

              min-w-0

              gap-3

              mt-4
            "
            style={{
              gridTemplateColumns:
                `minmax(150px, 0.7fr) repeat(${count}, minmax(0, 1fr))`,
            }}
          >

            <div />

            {filteredSessions.map(
              (session) => (
                <div
                  key={
                    `action-${session.id}`
                  }
                  className="
                    min-w-0
                    max-w-full
                  "
                >
                  <JoinButton
                    session={
                      session
                    }
                  />
                </div>
              )
            )}

          </div>

        </div>
      );
    };


  // =====================================================
  // MAIN UI
  // =====================================================

  return (
    <div
      className="
        min-h-screen

        w-full
        max-w-full
        min-w-0

        bg-secondary

        overflow-x-hidden

        px-3
        sm:px-4
        md:px-5
        lg:px-6

        py-4
        md:py-5
        lg:py-6
      "
    >

      {/* ===============================================
          LOADING
      =============================================== */}

      {loading && (
        <div
          className="
            flex
            items-center
            justify-center

            py-12

            text-gray-500
          "
        >
          Loading sessions...
        </div>
      )}


      {/* ===============================================
          ERROR
      =============================================== */}

      {error && (
        <div
          className="
            text-center

            text-red-500

            py-5

            break-words
          "
        >
          {error}
        </div>
      )}


      {/* ===============================================
          NO SESSIONS
      =============================================== */}

      {!loading &&
        sessions.length === 0 && (
          <div
            className="
              text-center

              text-black

              py-12
            "
          >
            No sessions available
          </div>
        )}


      {/* ===============================================
          SESSION LIST
          ONE RENDER PATH ONLY
      =============================================== */}

      {!loading &&
        sessions.length > 0 &&
        !selectedSession && (

          filteredSessions.length === 0 ? (

            <div
              className="
                text-center
                py-10
              "
            >
              <p
                className="
                  text-red-500
                  font-medium
                "
              >
                There are no classes
                scheduled today
              </p>

              {nextClass && (
                <p
                  className="
                    text-sm
                    text-gray-500
                    mt-2

                    break-words
                  "
                >
                  Your next class:{" "}
                  {new Date(
                    nextClass.startdatetime
                  ).toLocaleString()}
                </p>
              )}
            </div>

          ) : (

            <>
              {/* =======================================
                  DESKTOP
                  1024px+
              ======================================= */}

              <DesktopSessionTable />


              {/* =======================================
                  TABLET
                  768px - 1023px
              ======================================= */}

              <div
                className="
                  hidden
                  md:grid
                  lg:hidden

                  grid-cols-2

                  gap-4

                  w-full
                  max-w-full
                  min-w-0
                "
              >
                {filteredSessions.map(
                  (
                    session,
                    index
                  ) => (
                    <SessionCard
                      key={
                        session.id
                      }
                      session={
                        session
                      }
                      index={
                        index
                      }
                    />
                  )
                )}
              </div>


              {/* =======================================
                  MOBILE
                  < 768px
              ======================================= */}

              <div
                className="
                  grid
                  md:hidden

                  grid-cols-1

                  gap-4

                  w-full
                  max-w-full
                  min-w-0
                "
              >
                {filteredSessions.map(
                  (
                    session,
                    index
                  ) => (
                    <SessionCard
                      key={
                        session.id
                      }
                      session={
                        session
                      }
                      index={
                        index
                      }
                    />
                  )
                )}
              </div>

            </>
          )
        )}


      {/* ===============================================
          CONTENT DETAILS
      =============================================== */}

      {isStudent &&
        selectedSession && (

          <div
            className="
              w-full
              max-w-full
              min-w-0

              mt-2
            "
          >

            {/* HEADER */}

            <div
              className="
                w-full

                flex
                flex-col
                sm:flex-row

                sm:items-center
                sm:justify-between

                gap-4

                mb-5
              "
            >

              <div
                className="
                  min-w-0
                "
              >
                <h2
                  className="
                    text-xl
                    sm:text-2xl

                    font-bold

                    text-[#4338CA]

                    break-words
                  "
                >
                  {selectedSession.topic}
                </h2>

                <p
                  className="
                    mt-1

                    text-gray-500

                    break-words
                  "
                >
                  {selectedSession.subject}
                  {" • "}
                  {selectedSession.chapter}
                </p>
              </div>


              <button
                type="button"
                onClick={() => {
                  setSelectedSession(
                    null
                  );

                  setTopicContents(
                    []
                  );
                }}
                className="
                  w-full
                  sm:w-auto

                  shrink-0

                  border
                  border-[#4338CA]

                  text-[#4338CA]

                  px-5
                  py-2.5

                  rounded-full

                  hover:bg-[#4338CA]
                  hover:text-white

                  transition
                "
              >
                Back
              </button>

            </div>


            {/* CONTENT */}

            {contentLoading ? (

              <div
                className="
                  text-center
                  py-10
                  text-gray-500
                "
              >
                Loading contents...
              </div>

            ) : topicContents.length === 0 ? (

              <div
                className="
                  text-center
                  py-10
                  text-gray-400
                "
              >
                No content available
              </div>

            ) : (

              <div
                className="
                  w-full
                  max-w-full
                  min-w-0

                  space-y-4
                "
              >

                {topicContents.map(
                  (
                    content,
                    index
                  ) => (

                    <div
                      key={
                        content.contentid ||
                        content.id ||
                        index
                      }
                      className="
                        w-full
                        max-w-full
                        min-w-0

                        rounded-xl

                        border
                        border-[#E5DDCF]

                        bg-[#F8F4EA]

                        p-4

                        overflow-hidden
                      "
                    >

                      <p
                        className="
                          font-semibold
                          text-[#17204D]

                          break-words
                        "
                      >
                        {content.title ||
                          content.contentname ||
                          content.name ||
                          "Content"}
                      </p>

                      <p
                        className="
                          mt-1

                          text-sm
                          text-gray-500

                          break-words
                        "
                      >
                        {content.mediatype ||
                          ""}
                      </p>

                    </div>

                  )
                )}

              </div>
            )}

          </div>
        )}

    </div>
  );
}


// =====================================================
// MOBILE INFO ROW
// =====================================================

function MobileInfoRow({
  label,
  value,
  rating,
}) {
  return (
    <div
      className="
        w-full
        min-w-0

        px-4
        sm:px-5

        py-4
      "
    >

      <div
        className="
          font-semibold

          text-[#17204D]

          text-sm
          sm:text-base
        "
      >
        {label}
      </div>


      <div
        className="
          mt-1

          text-[#25245D]

          text-sm
          sm:text-base

          break-words
          overflow-wrap-anywhere
        "
      >
        {value}

        {rating && (
          <span
            className="
              inline-flex

              ml-2
              mt-1

              px-2
              py-1

              rounded-full

              border
              border-[#DCCFB8]

              text-xs

              text-[#716A80]

              whitespace-nowrap
            "
          >
            ★ {rating}
          </span>
        )}
      </div>

    </div>
  );
}


// =====================================================
// DESKTOP TABLE ROW
// =====================================================

function DesktopRow({
  label,
  sessions,
  renderValue,
  last = false,
}) {
  const count =
    Math.max(
      sessions.length,
      1
    );


  return (
    <div
      className={`
        grid

        w-full
        max-w-full
        min-w-0

        ${
          !last
            ? "border-b border-[#E5DDCF]"
            : ""
        }
      `}
      style={{
        gridTemplateColumns:
          `minmax(150px, 0.7fr) repeat(${count}, minmax(0, 1fr))`,
      }}
    >

      {/* LABEL */}

      <div
        className="
          min-w-0

          min-h-[52px]

          px-4
          py-4

          flex
          items-center

          bg-[#F8F4EA]

          text-[#151A50]

          text-sm
          lg:text-base

          font-semibold

          break-words
        "
      >
        {label}
      </div>


      {/* VALUES */}

      {sessions.map(
        (session) => (
          <div
            key={
              `${label}-${session.id}`
            }
            className="
              min-w-0
              max-w-full

              min-h-[52px]

              px-4
              py-4

              bg-[#F8F4EA]

              text-[#25245D]

              text-sm
              lg:text-base

              break-words
              overflow-wrap-anywhere
            "
          >
            {renderValue(
              session
            )}
          </div>
        )
      )}

    </div>
  );
}



















